import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { AuthService as AuthInstance } from "./services/firebase/firebaseServiceNEW";
import PhoneInput from 'react-phone-number-input/input'
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { states } from './constants/constants';


export default function UserAdd() {
    const navigate = useNavigate();


    const elementOptions = states.map((item, index) => {
        return (
            <option value={item.value} key={index}> {item.info} </option>
        );
    });

    const captchaRef = React.useRef(null);
    const user = useSelector(state => state.user);
    const userType = useSelector(state => state.user.userType);

    const [isPhoneVerify, setIsPhoneVerify] = useState(0);
    const [bankFields, setBankInfo] = useState({});

    const [ownersInsurancePolicy, setOwnersInsurancePolicy] = useState('');
    const [govermentIssuedID, setGovermentIssuedID] = useState('');



    const handlePDFPreview = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setOwnersInsurancePolicy(e.target.result);
            };
            reader.readAsDataURL(file);
        }

    };

    const openPDFModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModal').classList.add('show');
        document.getElementById('pdfPreviewModal').style.display = 'block';
    };

    const closePDFModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModal').classList.remove('show');
        document.getElementById('pdfPreviewModal').style.display = 'none';
    };


    const handlePDFTwoPreview = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setGovermentIssuedID(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const openPDFTwoModal = (event) => {
        event.preventDefault();
        document.getElementById('pdfPreviewModalTwo').classList.add('show');
        document.getElementById('pdfPreviewModalTwo').style.display = 'block';
    };

    const closePDFTwoModal = () => {
        document.getElementById('pdfPreviewModalTwo').classList.remove('show');
        document.getElementById('pdfPreviewModalTwo').style.display = 'none';
    };


    const {
        register: register2,
        handleSubmit: handleSubmit2,
        formState: { errors: errors2 },
        reset2
    } = useForm();

    async function handleProfileSubmit(inputFields) {
        if (inputFields.newPassword) {
            if (inputFields.newPassword === inputFields.currentPassword) {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    html: `<strong>Please use Different values</strong>`,
                });
            } else {
                try {
                    Swal.fire({
                        title: 'Updating, please wait',
                        html:
                            '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                        showConfirmButton: false,
                        showCancelButton: false,
                        focusConfirm: false,
                    });
                    const result = await AuthInstance.changePassword(inputFields.currentPassword, inputFields.newPassword);
                    console.log('result', result);
                    if (result === true) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success...',
                            html: `<strong>Password change successfully.</strong>`,
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            html: `<strong>${result ? result : 'Something happened in the log'}. Please try again</strong>`,
                        });
                    }
                } catch (error) {
                    // console.error('Error:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'An error occurred while changing the password. Please try again later.',
                    });
                }
            }
        }
    }


    function checkPhoneNumber(phoneNumber) {
        const regex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
        console.log(regex.test(phoneNumber));
        return regex.test(phoneNumber);
    }


    useEffect(() => {
        window.recaptchaVerifier = new AuthInstance.authMethod.RecaptchaVerifier(captchaRef.current || 'captcha', {
            'size': 'invisible',
            'callback': function (response) {
                console.log('Captcha Solved', response);
            }
        });

        window.recaptchaVerifier.render().then(function (widgetId) {
            window.recaptchaWidgetId = widgetId;
        })
    }, []);


    function ChnagePhone() {
        setIsPhoneVerify(0)
    }

    const verifyPhoneNumber = async (phoneNumber) => {

        try {
            phoneNumber = phoneNumber.replace(/\s+/g, '');

            if (!phoneNumber) {
                Swal.fire({
                    icon: 'error',
                    title: 'No phone number',
                });

            }
            if (!checkPhoneNumber(phoneNumber)) {
                Swal.fire({
                    icon: 'error',
                    title: 'Phone Number isn\'t valid',
                });
            }
            else {
                Swal.fire({
                    title: 'Updating, please wait',
                    html:
                        '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                    showConfirmButton: false,
                    showCancelButton: false,
                    focusConfirm: false,
                });
                const appVerifier = window.recaptchaVerifier;
                const response = await axios.post(`${process.env.REACT_APP_API_URL}`, {
                    action: 'CheckPhoneNumber',
                    phoneNumber: phoneNumber,
                    id: user.uid
                });

                if (response.data.status) {
                    Swal.fire({
                        title: 'Alert',
                        text: response.data.message,
                        icon: 'info',
                    });
                } else {

                    const AskOTPCodeMY = await AuthInstance.AskOTPCode(phoneNumber, appVerifier, getCodeForLink);

                    if (AskOTPCodeMY.error) {
                        // Error scenario
                        Swal.fire({
                            icon: 'error',
                            title: AskOTPCodeMY.error || 'Error verifying phone number',
                        });
                    } else if (AskOTPCodeMY && AskOTPCodeMY.confirmationResult) {
                        await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'UpdatePhoneNumber', phoneNumber: phoneNumber, user: user.uid });

                        Swal.fire({
                            icon: 'success',
                            title: 'Your phone number has been verified',
                        });

                        console.log(AskOTPCodeMY.confirmationResult);
                    }
                }
            }
        } catch (error) {
            Swal.close();
            Swal.fire({
                title: 'There was a problem',
                text: error ? `Error fetching data: ${error.message}` : 'Please, try again or contact SAGE Parents',
                icon: 'error',
            });
            console.error('Error fetching data:', error);
        }
    }

    async function getCodeForLink() {
        let verificationCode;
        const result = await Swal.fire({
            title: 'Enter the SMS code that we just sent you',
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Submit',
            showLoaderOnConfirm: true,
            preConfirm: (code) => {
                verificationCode = code;
            },
            allowOutsideClick: () => !Swal.isLoading()
        })

        if (result.value) {
            Swal.fire({
                title: 'Loading, please wait',
                html:
                    '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                showConfirmButton: false,
                showCancelButton: false,
                focusConfirm: false,
            });

        }

        return verificationCode
    }

    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        watch,
        reset
    } = useForm();

    const [dataEdit, setDataEdit] = useState({});
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetUserbyId', id: user.uid });
                const userMetaq = response.data.data;
                // console.log('userMetaq', userMetaq)
                reset({
                    email: userMetaq.email || '',
                    title: userMetaq.title || '',
                    firstname: userMetaq.firstname || '',
                    lastname: userMetaq.lastname || '',
                    mailingAddress: userMetaq.mailingAddress || '',
                    city: userMetaq.city || '',
                    state: userMetaq.state || '',
                    phoneNumber: userMetaq.phoneNumber || '',
                    zipCode: userMetaq.zipCode || '',
                    birthday: userMetaq.birthday && userMetaq.birthday !== '0000-00-00' ? new Date(userMetaq.birthday) : null || '',
                    SSN: userMetaq.SSN || '',
                    isPhoneVerify: userMetaq.isPhoneVerify || '',
                    stripeEmail: userMetaq.stripeEmail || '',
                    userType: userMetaq.userType || '',
                });

                setIsPhoneVerify(userMetaq.isPhoneVerify || 0);
                setDataEdit(userMetaq);
                setOwnersInsurancePolicy(userMetaq.ownersInsurancePolicy ? process.env.REACT_APP_UPLOAD_URL + userMetaq.ownersInsurancePolicy : '')
                setGovermentIssuedID(userMetaq.govermentIssuedID ? process.env.REACT_APP_UPLOAD_URL + userMetaq.govermentIssuedID : '')
            } catch (error) {
                // Handle errors here
                console.error('Error fetching user data:', error);
            }
        };

        fetchData();

    }, [user, reset]);


    async function handleBankSubmit(stripeEmail) {
        if (stripeEmail) {
            if (user && user.uid) {
                Swal.fire({
                    title: 'Updating, please wait',
                    html:
                        '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                    showConfirmButton: false,
                    showCancelButton: false,
                    focusConfirm: false,
                });
                const mylastetsurl = 'https://garagexy.com/API/stripe/connect_account.php';

                const formData = {
                    action: 'CreateUserStripeAccount',
                    id: user.uid,
                    email: stripeEmail
                }
                await axios.post(mylastetsurl, formData)
                    .then(response => {
                        Swal.close();
                        if (response.data.status === true) {
                            Swal.fire({
                                title: 'Please Click the button below to complete stripe Verification',
                                html: '<a class="btn btn-primary" href="' + encodeURI(response.data.onboarding_url) + '" target="_blank">Complete Stripe Verification</a>',
                                icon: 'success',
                                showConfirmButton: false,
                                showCancelButton: true,
                            });
                        } else {
                            Swal.fire(
                                'Alert',
                                'Error: ' + response.data.error,
                                'error'
                            );
                        }
                    })
                    .catch(error => {
                        Swal.close();
                        Swal.fire(
                            'There were a problem',
                            'Please, try again or contact SAGE Parents',
                            'error'
                        );
                    });
            }
        } else {
            Swal.fire(
                'Alert',
                'Email Required',
                'error'
            );
        }
    }


    const htmlComment = '<!-- TERMS OF USE 1. THE MATERIALS ARE PROVIDED "AS IS" AND WITHOUT WARRANTIES OF ANY KIND. 2. DO NOT REMOVE THE TEXT OF "powered by usbanklocations.com" 3. COPYRIGHT BELONGS TO USBANKLOCATIONS.COM 4. DO NOT REMOVE THE TERMS OF USE -->';



    const SubmitInformation = (userInfo) => {
        if (user && user.uid) {
            Swal.fire({
                title: 'Saving, please wait',
                html:
                    '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
                showConfirmButton: false,
                showCancelButton: false,
                focusConfirm: false,
            });
            const formData = new FormData();
            formData.append('action', 'UpdateUserMeta');
            formData.append('id', user.uid);

            formData.append('title', userInfo.title ? userInfo.title : '');
            formData.append('firstname', userInfo.firstname ? userInfo.firstname : '');
            formData.append('lastname', userInfo.lastname ? userInfo.lastname : '');
            formData.append('mailingAddress', userInfo.mailingAddress ? userInfo.mailingAddress : '');
            formData.append('city', userInfo.city ? userInfo.city : '');
            formData.append('state', userInfo.state ? userInfo.state : '');
            formData.append('zipCode', userInfo.zipCode ? userInfo.zipCode : '');
            formData.append('phoneNumber', userInfo.phoneNumber ? userInfo.phoneNumber : '');
            formData.append('isPhoneVerify', userInfo.isPhoneVerify ? userInfo.isPhoneVerify : 0);
            formData.append('birthday', userInfo.birthday && userInfo.birthday !== '0000-00-00' ? format(new Date(userInfo.birthday), 'yyyy/MM/dd') : '');
            formData.append('SSN', userInfo.SSN ? userInfo.SSN : '');

            formData.append('ownersInsurancePolicy', userInfo.garageInsurance ? userInfo.garageInsurance : '');
            formData.append('govermentIssuedID', userInfo.garageSampleContract ? userInfo.garageSampleContract : '');


            axios.post(`${process.env.REACT_APP_API_URL}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
                .then(response => {
                    console.log(response.data.data);
                    Swal.close();
                    if(response.data.status){
                    Swal.fire(
                        'User Updated',
                        'Your data has been updated',
                        'success'
                    ).then(
                        navigate(0)
                    )
                    }else{
                        Swal.fire(
                            'There were a problem',
                            'Please, try again or contact us',
                            'error'
                        ); 
                    }
                })
                .catch(error => {
                    Swal.close();
                    Swal.fire(
                        'There were a problem',
                        'Please, try again or contact SAGE Parents',
                        'error'
                    );
                });
        }

    }


    return (
        <section className="page-content sec-padding">

            <div className="container">
                <div className="page-content-details">
                    <div className="banner-details text-center pb-4">
                        <h3 className="mx-auto text-primary text-uppercase">Edit Profile</h3>
                        <small className="text-uppercase">Account Type {userType}</small>
                    </div>
                    <div className="row">
                        <div className="col-md-10 mx-auto">
                            <div className="card AddressView">
                                <div className="card-body">
                                    <form className="mb-4" onSubmit={handleSubmit2(handleProfileSubmit)}>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="email"> Email <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="email" type="text"
                                                    className="form-control"
                                                    disabled
                                              //      {...register2("email", { required: true })}
                                                    defaultValue={user.email}
                                                />

                                                {errors2.email &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">Email is required!</span>
                                                    </span>
                                                }

                                            </div>
                                        </div>
                                      
                                    </form>


                                    <h2>User Information</h2>
                                    <form className="mb-4" onSubmit={handleSubmit(SubmitInformation)}>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="title"> Title <i className="text-secondary xsmall">(opt)</i></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <select name="title"
                                                    className="form-control"
                                                    {...register("title", { required: true })}
                                                    defaultValue={user.title}
                                                >
                                                    <option value="">Select Title</option>
                                                    <option value="-"></option>
                                                    <option value="mr">Mr</option>
                                                    <option value="mrs">Mrs</option>
                                                    <option value="ms">Ms</option>
                                                    <option value="miss">Miss</option>
                                                    <option value="mx">Mx</option>
                                                </select>

                                                {errors.title &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">Title is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="firstname"> First Name <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="firstname" type="text"
                                                    className="form-control"
                                                    {...register("firstname", { required: true })}
                                                    defaultValue={user.firstname}
                                                />

                                                {errors.firstname &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">First Name is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="lastname"> Last Name  <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="lastname" type="text"
                                                    className="form-control"
                                                    {...register("lastname", { required: true })}
                                                    defaultValue={user.lastname}
                                                />

                                                {errors.lastname &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">Last Name is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="mailingAddress"> Mailing Address  <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="mailingAddress" type="text"
                                                    className="form-control"
                                                    {...register("mailingAddress", { required: true })}
                                                    defaultValue={user.mailingAddress}
                                                />

                                                {errors.mailingAddress &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">Address is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="city"> City  <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="city" type="text"
                                                    className="form-control"
                                                    {...register("city", { required: true })}
                                                    defaultValue={user.city}
                                                />

                                                {errors.city &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">City is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="state"> State  <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <select name="state" type="text"
                                                    className="form-select"
                                                    value={user.state}
                                                    {...register("state", { required: true })}
                                                >
                                                    <option>All States</option>
                                                    {elementOptions} </select>

                                                {/* <input name="state" type="text"
                                                    className="form-control"
                                                    {...register("state", { required: true })}
                                                    defaultValue={user.state}
                                                /> */}

                                                {errors.state &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">State is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="phoneNumber"> Mobile Phone  <span className="text-danger">*</span></label>
                                            <div className="col-md-5 d-flex position-relative">
                                                <Controller
                                                    name="phoneNumber"
                                                    control={control}
                                                    rules={{ required: 'Mobile Phone is required!' }}
                                                    render={({ field }) => (
                                                        <PhoneInput
                                                            defaultCountry="US"
                                                            placeholder='(555) 555-5555'
                                                            className="form-control"
                                                            maxLength='14'
                                                            value={field.value ?? '+' + dataEdit.phoneNumber}
                                                            onChange={(value) => field.onChange(value)}
                                                            readOnly={isPhoneVerify === '1' ? true : false}
                                                        />
                                                    )}
                                                />

                                                {errors.phoneNumber &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">Mobile Phone is required!</span>
                                                    </span>
                                                }
                                            </div>

                                            <div className="col-md-3">
                                                {isPhoneVerify == '1' ?
                                                    (
                                                        <>
                                                            <small>Verified</small><br />
                                                            <a className="btn btn-primary" onClick={ChnagePhone}>Change Number</a>
                                                        </>
                                                    ) :
                                                    (
                                                        <button type="button" className="btn btn-primary" onClick={() => verifyPhoneNumber(getValues("phoneNumber"))}>Verify</button>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="zipCode"> ZIP/Postal Code  <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="zipCode" type="text"
                                                maxLength={6}
                                                    className="form-control"
                                                    {...register("zipCode", { required: true })}
                                                    defaultValue={user.zipCode}
                                                />

                                                {errors.zipCode &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text"> ZIP/Postal Code is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="birthday"> Date Of Birth  <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <Controller
                                                    control={control}
                                                    name="birthday"
                                                    rules={{ required: true }}
                                                    render={({ field }) => (
                                                        <DatePicker
                                                            selected={field.value}
                                                            onChange={(date) => {
                                                                field.onChange(date);
                                                            }}
                                                            dateFormat="MM/dd/yyyy"
                                                            placeholderText="MM/dd/yyyy"
                                                            maxDate={new Date()}
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            dropdownMode="select"
                                                            className="form-control"
                                                        />
                                                    )}
                                                />
                                                {errors.birthday &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">DOB is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="SSN"> Social Security Number  <span className="text-danger">*</span></label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input name="SSN" type="text"
                                                    className="form-control"
                                                    {...register("SSN", { required: true })}
                                                    defaultValue={user.SSN}
                                                />

                                                {errors.SSN &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">Social Security Number is required!</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>


                                        <h2>Documents</h2>

                                        {getValues("userType") === 'Owner' &&
                                            <>
                                                <div className="form-group row">
                                                    <label className="form-label col-md-4" htmlFor="ownersInsurancePolicy">Owners Insurance Policy  <span className="text-danger">*</span></label>
                                                    <div className="col-md-8 d-flex justify-content-between position-relative">
                                                        <Controller
                                                            name="garageInsurance"
                                                            control={control}
                                                            rules={{ required: ownersInsurancePolicy ? false : true }}
                                                            render={({ field }) => (
                                                                <>
                                                                    <input
                                                                        ref={field.ref}
                                                                        id="garageInsurance"
                                                                        type="file"
                                                                        className="form-file form-control"
                                                                        accept=".pdf"
                                                                        onChange={(e) => {
                                                                            handlePDFPreview(e);
                                                                            field.onChange(e.target.files[0]);
                                                                        }}
                                                                    />
                                                                    <label htmlFor="garageInsurance" className="btn btn-primary btn-lg">Choose a File</label>
                                                                    {ownersInsurancePolicy &&
                                                                        <button type="button" className="btn btn-primary btn-lg" onClick={openPDFModal}>View Insurance</button>
                                                                    }
                                                                    {errors.garageInsurance &&
                                                                        <span className="text-danger la la-exclamation-circle error-icon">
                                                                            <span className="badge badge-danger error-icon-text">Owners Insurance Policy is required!</span>
                                                                        </span>
                                                                    }
                                                                </>
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                        }

                                        {ownersInsurancePolicy &&
                                            <div className="modal fade" id="pdfPreviewModal" tabIndex="-1" role="dialog">
                                                <div className="modal-dialog modal-xxl" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title">Owners Insurance Policy</h5>
                                                            <button type="button" className="btn-close close" data-dismiss="modal" aria-label="Close" onClick={closePDFModal}>
                                                                <span aria-hidden="true"></span>
                                                            </button>
                                                        </div>
                                                        <div className="modal-body">
                                                            <embed src={ownersInsurancePolicy} type="application/pdf" width="100%" height="500px" />
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFModal}>Close</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }


                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="govermentIssuedID"> Goverment Issued ID  <span className="text-danger">*</span></label>

                                            <div className="col-md-8 d-flex justify-content-between  position-relative">



                                                <Controller
                                                    name="garageSampleContract"
                                                    control={control}
                                                    rules={{ required: govermentIssuedID ? false : true }}
                                                    render={({ field }) => (
                                                        <>
                                                            <input
                                                                ref={field.ref}
                                                                id="garageSampleContract"
                                                                type="file"
                                                                className="form-file form-control"
                                                                accept=".pdf"
                                                                onChange={(e) => {
                                                                    handlePDFTwoPreview(e);
                                                                    field.onChange(e.target.files[0]);
                                                                }}
                                                            />
                                                            <label htmlFor="garageSampleContract" className="btn btn-primary btn-lg">Choose a File</label>
                                                            {govermentIssuedID &&
                                                                <button className="btn btn-primary btn-lg" onClick={openPDFTwoModal}>View Issued ID</button>
                                                            }


                                                            {errors.garageSampleContract &&
                                                                <span className="text-danger la la-exclamation-circle error-icon">
                                                                    <span className="badge badge-danger error-icon-text"> Goverment Issued ID!</span>
                                                                </span>
                                                            }

                                                        </>
                                                    )}
                                                />


                                            </div>
                                        </div>

                                        {govermentIssuedID &&
                                            <div className="modal fade" id="pdfPreviewModalTwo" tabIndex="-1" role="dialog">
                                                <div className="modal-dialog modal-xxl" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5 className="modal-title">Goverment Issued ID</h5>

                                                            <button type="button" className="btn-close  close" data-dismiss="modal" aria-label="Close" onClick={closePDFTwoModal}>
                                                                <span aria-hidden="true"></span>
                                                            </button>
                                                        </div>
                                                        <div className="modal-body">
                                                            <embed src={govermentIssuedID} type="application/pdf" width="100%" height="500px" />
                                                        </div>
                                                        <div className="modal-footer">
                                                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={closePDFTwoModal}>Close</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <div className="form-group text-center">
                                            <button type="submit" className="btn btn-primary btn-lg mt-2" >Update Profile</button>

                                        </div>


                                        {getValues("userType") === 'Owner' &&
                                            <>
                                                <h2>Payment Details</h2>
                                                <div className="form-group row">
                                                    <label className="form-label col-md-4" htmlFor="stripeEmail"> Stripe Account Email  <span className="text-danger">*</span></label>
                                                    <div className="col-md-6 d-flex position-relative">
                                                        <input type="text" name="stripeEmail"
                                                            readOnly={dataEdit.stripe_verified === '1' ? true : false}
                                                            className="form-control"
                                                            {...register("stripeEmail")}
                                                            defaultValue={user.stripeEmail}
                                                        />


                                                        {errors.stripeEmail &&
                                                            <span className="text-danger la la-exclamation-circle error-icon">
                                                                <span className="badge badge-danger error-icon-text">Stripe Account Email is required!</span>
                                                            </span>
                                                        }
                                                    </div>
                                                    <div className="col-md-2">
                                                        {dataEdit.stripe_verified === '1' ? '' :
                                                            <button type="button" className="btn btn-primary" onClick={() => handleBankSubmit(getValues("stripeEmail"))}>Update Stripe Account</button>
                                                        }
                                                    </div>
                                                </div>
                                                {dataEdit.stripe_id &&
                                                    <div className="form-group row">
                                                        <label className="form-label col-md-4" htmlFor="stripeEmail"> Stripe Account Id  <i className="text-secondary xsmall">(automatic)</i></label>
                                                        <div className="col-md-8">
                                                            <input type="text" value={dataEdit.stripe_id} className="form-control" readOnly="true" />

                                                            {dataEdit.stripe_verified === '1' ? (
                                                                'verified'
                                                            ) : (
                                                                <>
                                                                    <span className="text-danger">Your account is not verified yet.</span>{'\n'}
                                                                    {dataEdit.account_url &&
                                                                        <a
                                                                            target="_blank" className="btn btn-primary mt-2" href={dataEdit.account_url}>Complete Stripe Verification</a>
                                                                    }
                                                                </>
                                                            )}</div>
                                                    </div>
                                                }
                                            </>
                                        }


                                    </form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id='captcha' ref={captchaRef}>
            </div>
        </section>
    )
}